module.exports = __webpack_public_path__ + "static/media/alessia.2339aab8.png";